'use client';

import React from 'react';
import AppLayout from '@/components/AppLayout';
import CosmeticChecklistClient from './components/CosmeticChecklistClient';

export default function CosmeticChecklistPage() {
  return (
    <AppLayout>
      <CosmeticChecklistClient />
    </AppLayout>
  );
}
